require('./grayscale');

$(function () {
    $('.top-tab-nav-item').hover(function () {
        if (!$(this).hasClass('top-tab-nav-item-tv')) {
            $('.top-tv').slideUp('fast');
        }
    }, function () {
    });
});